/**
 * Bookings service – public (non-admin) booking APIs.
 * Uses GET /bookings/v1/:bookingId/experience-details for latest experience details by booking ID.
 */

const getBaseUrl = () => process.env.NEXT_PUBLIC_API_URL || '';

export type ExperienceDetailsBookingType =
  | 'package'
  | 'guided_activity'
  | 'stay_experience';

export interface GetExperienceDetailsByBookingIdResponse {
  success: boolean;
  message?: string;
  data?: {
    bookingType: ExperienceDetailsBookingType;
    experienceDetails: unknown;
  };
}

/**
 * Fetches the latest experience details for a booking (uses snapshot when the booking has been modified).
 * Route: GET /bookings/v1/:bookingId/experience-details (public, no admin auth).
 */
export async function getExperienceDetailsByBookingId(
  bookingId: string
): Promise<GetExperienceDetailsByBookingIdResponse> {
  const baseUrl = getBaseUrl();
  const url = `${baseUrl}/bookings/v1/${encodeURIComponent(bookingId)}/experience-details`;
  const response = await fetch(url);
  const json =
    (await response.json()) as GetExperienceDetailsByBookingIdResponse;
  if (!response.ok) {
    throw new Error(
      json.message || `Failed to load experience details (${response.status})`
    );
  }
  return json;
}
